<script setup>
import CounterItem from '@/Components/Blocks/Counter/CounterItem.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
    ref: String,
    animationPaused: Boolean,
    counters: Array,
});

const { t } = useI18n();
</script>

<template>
    <div class="relative flex flex-col gap-6 md:flex-row" :ref="ref">
        <CounterItem
            v-for="(counter, i) in counters"
            :countTo="counter.counter_number"
            :durationCounter="3"
            :delayCounter="1"
            :label="counter.counter_title"
            :description="counter.counter_description"
            :animationPaused="animationPaused"
            class="bg-yellow-light 2xl:min-h-70"
        />
    </div>
</template>
